import { useSearchExamEventReportItemsQuery } from '@report/graphql';
import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { ORDER_TYPE } from '@shared/graphql';
import { useDisclosure } from '@shared/hooks';
import { toDayRange } from '@shared/utils';

import { useExamEventOverviewReportSearchParams } from '../../hooks';
import { ExamEventOverviewReportExportModal } from '../exam-event-overview-report-export-modal';

export default function ExamEventOverviewReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();
  const [
    {
      page,
      pageSize,
      sortBy,
      sortOrder,
      startDate,
      endDate,
      examCenter,
      examType,
      registrationType,
      province,
    },
  ] = useExamEventOverviewReportSearchParams();

  const isSearchEmpty =
    !startDate &&
    !endDate &&
    !examCenter.length &&
    !examType.length &&
    !registrationType.length &&
    !province.length;

  const { startedAt, endedAt } = toDayRange(startDate, endDate);

  const { data } = useSearchExamEventReportItemsQuery({
    variables: {
      searchExamEventReportItemsInput: {
        filter: {
          examCenterCodes: examCenter.includes('all') ? null : examCenter,
          examTypes: examType,
          registrationTypes: registrationType,
          provinceIds: province.includes('all') ? null : province,
          startedAt: startedAt as Date,
          endedAt: endedAt as Date,
        },
        paging: {
          currentPage: page,
          pageSize,
        },
        order: {
          field: sortBy,
          type: ORDER_TYPE[sortOrder],
        },
      },
    },
    skip: isSearchEmpty,
    fetchPolicy: 'cache-first',
  });

  const totalCount = data?.reportSearchExamEventReportItems.total ?? 0;
  const shouldDisable = totalCount === 0;

  const handleClick = () => {
    openModal();
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={handleClick}
        disabled={shouldDisable}
      >
        Export
      </Button>
      <ExamEventOverviewReportExportModal
        open={isModalOpen}
        onClose={closeModal}
        totalCount={totalCount}
      />
    </>
  );
}
